import "flatpickr/dist/flatpickr.min.css";
import FlatpickrControl from './flatpickr-control';
// flatpickr
[].slice.call(document.querySelectorAll("[data-flatpickr], [data-flatpickr-time], [data-flatpickr-range]")).forEach((element) => {
    // init
    if (!element.hasAttribute("data-flatpickr-manual")) {
        const picker = new FlatpickrControl(element);
        picker.init();
    }
});
export default undefined;
